import React from 'react';
import ManoperaPicker from '../pickers/ManoperaPickerModal';
import {authFetch} from './authFetch';
export default function ManoperaPickerModal(props) {
  return <ManoperaPicker {...props} fetchClient={authFetch} />;
}
